module.exports = __webpack_public_path__ + "img/img2.c79d2c14.png";